import { API_URL_MAP, BASE_URL_MAP } from "constants/baseUrls";
import Environments from "constants/environments";

export const environment =
  BASE_URL_MAP[window.location.hostname] || Environments.local;

export const apiBaseURLs = API_URL_MAP.flashApi[environment];
